import { render, staticRenderFns } from "./ChatGptModal.vue?vue&type=template&id=db1b6f08&"
import script from "./ChatGptModal.vue?vue&type=script&lang=js&"
export * from "./ChatGptModal.vue?vue&type=script&lang=js&"
import style0 from "./ChatGptModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChatGptModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/ChatGptModal.vue
// module id = 2328
// module chunks = 1